import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

import React from 'react'

// Define the styled Typography component
const StyledTypography = styled(Typography)(({ theme, fontSize, color }) => ({
  backgroundColor: color,
  color: 'black',
  padding: '8px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  display: 'flex', // Use flexbox
  alignItems: 'center', // Center vertically
  justifyContent: 'center', // Optional: Center horizontally
  height: `${fontSize * 2}px`,
  fontSize: `${fontSize}px`,
  textOverflow: 'ellipsis',
  position: 'relative', // Position relative for the fab positioning
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}))

// Create the functional component with 'caption', 'font', and 'type' props
const Caption = ({
  caption,
  font,
  type,
  id,
  fontSize,
  capitalLetters,
  color,
}) => {
  return (
    <StyledTypography
      variant="h6"
      fontFamily={font}
      fontSize={fontSize}
      color={color}
    >
      {Boolean(capitalLetters) ? caption.toUpperCase() : caption}
    </StyledTypography>
  )
}

export default Caption
